import React from "react";
import DesktopInvitationDetails from "../../components/DesktopInvitationDetails";
import { useParams } from "react-router-dom";
import MobileSecViewsHeader from "../../components/MobileSecViewsHeader";

const MobileAccessKeyDetails = () => {
  const { id: selectedInvitationId } = useParams<{
    id: string;
  }>();

  

  return (
    <div className="w-100 h-100 border-box p-8 scroll">
      {selectedInvitationId && (
        <>
          <div className="mb-4">
            <MobileSecViewsHeader
              title={"Detalles de la invitación"}
              route={"/access-keys"}
            />
          </div>
          <DesktopInvitationDetails invitationId={selectedInvitationId} />
        </>
      )}
    </div>
  );
};

export default MobileAccessKeyDetails;
